// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","customLinkWrapper":"BuildTestActions__customLinkWrapper--IY","customLink":"BuildTestActions__customLink--z8"};